import { tgfFunctions } from "../../framework/tgfFunctions";
import { EffectsSettings } from "../../settings/Settings";
import { s_birdRed_yell } from "../AssetDefinitions/SpineDefinitions";
import { globalAddConeBlast } from "../SceneController";
import { BirdObjectDefault } from "./BirdObject";
export function BirdObjectRed(def, uid, x, y, angle, container) {
    BirdObjectRed.uber.constructor.call(this, def, uid, x, y, angle, container);
}
tgfFunctions.inherit(BirdObjectRed, BirdObjectDefault);
BirdObjectRed.prototype.spineInit = function () {
    "use strict";
    this.specialAbilityEffect = s_birdRed_yell.clone();
};
//returns true if the power was activated
BirdObjectRed.prototype.activateSpecialPower = function () {
    if (this.canUsePower && !this.firstContact) {
        globalAddConeBlast(this.x, this.y, this.animationAngle);
        this.playSound(this.soundStates.ABILITY, this.definition.sounds);
        if (this.specialAbilityEffect) {
            this.specialAbilityEffect.setScale(this.effectScale * EffectsSettings.redScaleFactor - 0.02);
            this.specialAbilityEffect.setAnimation("red_yell");
            this.specialAbilityEffect.setSpeed(EffectsSettings.redAnimationSpeed);
            this.specialAbilityEffect.setRotation(this.animationAngle + this.angle);
            this.container.addChild(this.specialAbilityEffect);
        }
        this.canUsePower = false;
        return true;
    }
    return false;
};
BirdObjectRed.prototype.step = function (timePassed) {
    BirdObjectRed.uber.step.call(this, timePassed);
    if (this.specialAbilityEffect) {
        this.specialAbilityEffect.setPosition(this.x, this.y);
    }
};
